import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Table,
  Form,
  Badge,
  InputGroup,
} from "react-bootstrap";
import "./_offlineExams.scss";
export default class ViewExams extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedClass: "Class III",
      search: "",
      exams: [
        {
          id: 1,
          className: "Class I",
          exam: "Formative Assessment I",
          date: "24 Jul - 26 Jul",
          status: "Pending",
          students: 230,
        },
        {
          id: 2,
          className: "Class II",
          exam: "Mid Term Exam",
          date: "28 Jul - 30 Jul",
          status: "Published",
          students: 180,
        },
        {
          id: 3,
          className: "Class III",
          exam: "Unit Test",
          date: "02 Aug - 04 Aug",
          status: "Verified",
          students: 210,
        },
      ],
    };
  }

  statusColor = (status) => {
    if (status === "Published") return "success";
    if (status === "Verified") return "primary";
    return "warning";
  };

  render() {
    return (
      <div
        style={{
          background: "#f4f8ff",
          padding: 25,
          borderRadius: 20,
        }}
      >
        {/* HEADER STATS */}
        <Row className="mb-4">
          {[
            {
              title: "Total Exams",
              value: "24",
              icon: "📘",
              type: "amber",
            },
            {
              title: "Upcoming",
              value: "8",
              icon: "🗓",
              type: "green",
            },
            {
              title: "Pending Verify",
              value: "5",
              icon: "⚠",
              type: "dark",
            },
            {
              title: "Students Covered",
              value: "1250",
              icon: "🎓",
              type: "blue",
            },
          ].map((card, index) => (
            <Col md={3} sm={6} xs={12} key={index}>
              <div className={`metric-card ${card?.type}`}>
                <div className="metric-left">
                  <div className="metric-title">{card.title}</div>

                  <div className="metric-value">{card.value}</div>
                </div>

                <div className="metric-icon">
                  <span>{card.icon}</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* FILTER PANEL */}
        <Card
          className="border-0 shadow-sm mb-4"
          style={{
            borderRadius: 20,
          }}
        >
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 style={{ fontWeight: 700 }}>Exam Explorer</h4>

              <Button variant="primary">+ Create New Exam</Button>
            </div>

            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Class</Form.Label>
                  <Form.Control as="select">
                    <option>Class I</option>
                    <option>Class II</option>
                    <option>Class III</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Control as="select">
                    <option>All</option>
                    <option>Pending</option>
                    <option>Published</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Label>Search</Form.Label>
                <InputGroup>
                  <Form.Control placeholder="Search exam..." />
                  <Button variant="success">Search</Button>
                </InputGroup>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* EXAM GRID */}
        <Card
          className="border-0 shadow-sm"
          style={{
            borderRadius: 20,
          }}
        >
          <Card.Body>
            <div className="d-flex justify-content-between mb-4">
              <h4 style={{ fontWeight: 700 }}>Exam Registry</h4>

              <Button variant="outline-primary">Export Report</Button>
            </div>

            <Table hover borderless responsive>
              <thead
                style={{
                  background: "#eef4ff",
                }}
              >
                <tr>
                  <th>Class</th>
                  <th>Exam</th>
                  <th>Dates</th>
                  <th>Students</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {this.state.exams.map((item) => (
                  <tr
                    key={item.id}
                    style={{
                      boxShadow: "0 2px 10px rgba(0,0,0,.03)",
                    }}
                  >
                    <td>
                      <h6 className="mb-0">{item.className}</h6>
                      <small className="text-muted">Academic Section</small>
                    </td>

                    <td>
                      <div style={{ fontWeight: 600 }}>{item.exam}</div>
                      <small className="text-muted">Scheduled Exam</small>
                    </td>

                    <td>{item.date}</td>

                    <td>
                      <Badge bg="light" text="dark">
                        {item.students} Students
                      </Badge>
                    </td>

                    <td>
                      <Badge
                        pill
                        bg={this.statusColor(item.status)}
                        style={{
                          padding: "8px 15px",
                        }}
                      >
                        {item.status}
                      </Badge>
                    </td>

                    <td>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="mr-2"
                      >
                        View
                      </Button>

                      <Button
                        size="sm"
                        variant="outline-warning"
                        className="mr-2"
                      >
                        Edit
                      </Button>

                      <Button size="sm" variant="outline-success">
                        Verify
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    );
  }
}
